import { render } from "./DoneerKnoppen.vue?vue&type=template&id=a8b30f22&scoped=true"
import script from "./DoneerKnoppen.vue?vue&type=script&lang=js"
export * from "./DoneerKnoppen.vue?vue&type=script&lang=js"

import "./DoneerKnoppen.vue?vue&type=style&index=0&id=a8b30f22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b30f22"]])

export default __exports__